import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2 } from "lucide-react";
import { BRAND, SOCIALS } from "@/config";
import { BrandLogo } from "@/components/BrandLogo";
import { Ornament } from "@/components/Ornament";

export function Footer() {
  return (
    <footer className="bg-cocoa text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <BrandLogo imgClassName="h-16 w-16 border-2 border-white/25" textClassName="font-script text-5xl leading-none text-white" />
          <Ornament className="mt-4 justify-start text-terracotta" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            Salsas artesanales gourmet, 100% hechas a mano por nuestra familia en {BRAND.city} desde {BRAND.since}.
            Hechas con puro amor y tradición. {BRAND.tagline}
          </p>
          <div className="mt-6 flex gap-3">
            <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/5 text-white transition-colors hover:bg-habanero hover:text-white">
              <Instagram size={18} />
            </a>
            <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/5 text-white transition-colors hover:bg-habanero hover:text-white">
              <Music2 size={18} />
            </a>
            <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/5 text-white transition-colors hover:bg-habanero hover:text-white">
              <Facebook size={18} />
            </a>
          </div>
        </div>
        <div>
          <h3 className="font-display text-lg font-bold text-white">Tienda</h3>
          <ul className="mt-4 space-y-2 text-sm text-white/60">
            <li><Link to="/tienda" className="transition-colors hover:text-corn" data-testid="footer-link-catalogo">Catálogo</Link></li>
            <li><Link to="/mayoreo" className="transition-colors hover:text-corn" data-testid="footer-link-mayoreo">Mayoreo</Link></li>
            <li><Link to="/cuenta" className="transition-colors hover:text-corn" data-testid="footer-link-cuenta">Mi cuenta / Mis pedidos</Link></li>
            <li><Link to="/faq" className="transition-colors hover:text-corn" data-testid="footer-link-faq">Preguntas frecuentes</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-lg font-bold text-white">La marca</h3>
          <ul className="mt-4 space-y-2 text-sm text-white/60">
            <li><Link to="/historia" className="transition-colors hover:text-corn" data-testid="footer-link-historia">Nuestra historia</Link></li>
            <li><Link to="/contacto" className="transition-colors hover:text-corn" data-testid="footer-link-contacto">Contacto</Link></li>
            <li><Link to="/politicas" className="transition-colors hover:text-corn" data-testid="footer-link-politicas">Políticas</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
        © {new Date().getFullYear()} SoyDiVa · Hecho con puro amor y tradición en Mérida, Yucatán
      </div>
    </footer>
  );
}
